export class PersonaGobernabilidad{
    idPersona: number;
    tipoDocumento: number;
    numeroDocumento: string;
    primerApellido: string;
    segundoApellido: string;
    razonSocial: string;
    primerNombre: string;
    segundoNombre: string;
    tipoPersona: number;
    tipoPersonaText: string;
    tipoEmpresa: number;
    tipoEmpresaText: string;
    porcentajeParticipacion: number;
    exclusion: boolean;
    editable: boolean;

    constructor(){
        this.restablecerGobernabilidad();
    }

    restablecerGobernabilidad(){
        this.idPersona=0;
        this.tipoDocumento=null;
        this.numeroDocumento="";
        this.primerApellido="";
        this.segundoApellido="";
        this.primerNombre="";
        this.razonSocial="";
        this.segundoNombre="";
        this.tipoPersona=null;
        this.tipoPersonaText="";
        this.tipoEmpresa=null;
        this.tipoEmpresaText="";
        this.porcentajeParticipacion=0;
        this.exclusion=false;
        this.editable=false;
    }

    cargarGobernabilidad(persona: any) {
        this.idPersona = persona.inIdPersona;
        this.tipoDocumento = persona.inCod_tipo_doc;
        this.numeroDocumento = persona.vcNro_doc.toString();
        this.primerApellido = persona.vcApellidoUno || "";
        this.primerNombre = persona.vcNombreUno || "";
        this.segundoApellido = persona.vcApellidoDos || "";
        this.segundoNombre = persona.vcNombreDos || "";
    }

    esValido(){
        if((this.tipoDocumento != 3 && this.primerNombre == "") ||
           this.primerApellido == "" ||
           this.numeroDocumento == "" ||
           !this.tipoDocumento ||
           !this.tipoPersona)
            return false;
        return true;
    }   
}